<template>
	<div class="p-3">
		<form ref="form" v-on:submit.prevent="create()" class="needs-validation was-validated" novalidate>
			<div class="position-relative">
				<div class="row justify-content-center align-items-stretch">
					<div class="col-md-9 mb-3">
						<input type="text" name="titulo" maxlength="50" v-model="form.titulo" class="form-control form-control-lg" placeholder="Añade un título" required>
					</div>
					<div class="col-md-12 text-center">
						<h3 class="text-muted mb-0">Seleccione el tipo de campaña que desea enviar</h3>
						<span v-if="errorValidation" class="text-danger">
							**{{errorValidation}}
						</span>
					</div>
					<div class="col-md-3 mb-3">
						<label class="cursor-pointer h-100 position-relative">
							<div class="custom-control custom-checkbox position-absolute" style="top: 10px; left: 10px;">
								<input type="checkbox" v-model="form.correo" class="custom-control-input" :disabled="loadingCreate"/>
								<label class="custom-control-label"></label>
							</div>
							<div :class="{'card h-100':true, 'border-primary':form.correo}">
								<div class="card-img-top">
									<img src="https://i1.wp.com/esferacreativa.com/wp-content/uploads/2020/03/ideas-para-mailing.png?resize=702%2C459&ssl=1" class="w-100" style="height: 130px; object-fit: cover; object-position: center;">
								</div>
								<div class="card-body">
									<h5 class="card-title">Emailing</h5>
									<p class="card-text">Envío de mensajes comerciales a través de correos electrónicos</p>
								</div>
							</div>
						</label>
					</div>
					<div class="col-md-3 mb-3">
						<label class="cursor-pointer h-100 position-relative">
							<div class="custom-control custom-checkbox position-absolute" style="top: 10px; left: 10px;">
								<input type="checkbox" v-model="form.sms" class="custom-control-input" :disabled="loadingCreate"/>
								<label class="custom-control-label"></label>
							</div>
							<div :class="{'card h-100':true, 'border-primary':form.sms}">
								<div class="card-img-top">
									<img src="https://36s112f5p5p13bahm28fteev-wpengine.netdna-ssl.com/wp-content/uploads/2019/09/smsmarketing-wpv_780x380_center_center.png" class="w-100" style="height: 130px; object-fit: cover; object-position: center;">
								</div>
								<div class="card-body">
									<h5 class="card-title">SMS</h5>
									<p class="card-text">Envío de mensajes comerciales a través de mensajes de texto</p>
								</div>
							</div>
						</label>
					</div>
					<div class="col-md-3">
						<label class="cursor-pointer h-100 position-relative">
							<div class="custom-control custom-checkbox position-absolute" style="top: 10px; left: 10px;">
								<input type="checkbox" v-model="form.whatsapp" class="custom-control-input" disabled="true"/>
								<label class="custom-control-label"></label>
							</div>
							<div :class="{'card h-100':true, 'border-primary':form.whatsapp}">
								<div class="card-img-top">
									<img src="https://static.facebook.com/images/whatsapp/www/whatsapp-promo.png" class="w-100" style="height: 130px; object-fit: cover; object-position: center;">
								</div>
								<div class="card-body">
									<h5 class="card-title">WhatsApp</h5>
									<p class="card-text">Envío de mensajes comerciales a través de WhatsApp</p>
								</div>
							</div>
						</label>
					</div>
				</div>
			</div>
			<div class="text-right p-3">
				<button type="button" class="btn btn-link" :disabled="loadingCreate" v-on:click="cancel()">Cancelar</button>
				<button type="submit" class="btn btn-primary" :disabled="loadingCreate || !validateForm">
					<span v-if="loadingCreate">
						<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
						Cargando...
					</span>
					<span v-else>
						Continuar
					</span>
				</button>
			</div>
		</form>
	</div>
</template>
<script type="text/javascript">
	export default {
		props: ['id'],

		data(){
			return {
				validateForm: false,
				loadingCreate: false,
				form: {
					titulo: '',
					correo: false,
					sms: false,
					whatsapp: false,
				},
				errorValidation: ''
			}
		},

		methods: {
			create(){
				this.checkValidity()
				if (!this.validateForm) {
					return
				}
				if (!this.form.correo && !this.sms && !this.form.whatsapp) {
					this.errorValidation = 'Debes seleccionar al menos una opción'
					return
				}
				this.loadingCreate = true
				axios.post(`api/campanas/${this.codigo}/eventos`, this.form).then(res =>{
					var data = res.data
					//this.form.code = data.CODIGO_EVENTO || -1
					this.$emit('input', data)
				}).catch(err=>{
					console.log(err.response)
				}).then(() => {
					this.loadingCreate = false
				})
			},
			cancel(){
				this.$emit('cancel', true)
			},
			checkValidity(){
				if (!this.$refs.form){
					this.validateForm = false
				}else{
					this.validateForm = this.$refs.form.checkValidity()
				}
			},
		},

		computed: {
			codigo(){
				return this.id || -1
			}
		},
		watch:{
			'form':{
				handler(val){
					this.checkValidity()
					return val
				},
				deep: true
			}
		},
	}
</script>